import AuthRepository from './authRepository'
import CheckRepository from './checkRepository'
import FileRepository from './fileRepository'
import addContragentsGroupRepository from './addContragentsGroupRepository'
import approvementsRepository from './approvementsRepository'
import autoRepository from './autoRepository'
import bidsRepository from './bidsRepository'
import callCenterRepository from './callCenterRepository'
import clientsRepository from './clientsRepository'
import contractsRepository from './contractRepository'
import contragentsRepository from './contragentsRepository'
import documentRepository from './documentRepository'
import driverRepository from './driverRepository'
import edmUsersRepository from './edmUsersRepository'
import groupRepository from './groupRepository'
import kladrRepository from './kladrRepository'
import libsRepository from './libsRepository'
import loadDayReposytory from './loadDayReposytory'
import managersRepository from './managersRepository'
import noPaperRepository from './noPaperRepository'
import poleRepository from '@/api/poleRepository'
import profileRepository from './profileRepository'
import statisticRepository from './statisticRepository'
import totalSearchRepository from './totalSearchRepository'
import ttnRepository from './ttnRepository'
import usersRepository from './usersRepository'
// import shareRepository from  "./shareRepository";
import actsRepository from './actsRepository'
import commentsRepository from '@/api/commentsRepository'
import contragentsGroupRepository from './contragentGroupRepository'
import hardwareRepository from '@/api/hardwareRepository'
import messagesRepository from '@/api/messagesRepository'
import organizationsRepository from './organizationsRepository'
import paymentsRepository from './paymentsRepository'
import registerOfPayments from '@/api/registerOfPayments'
import registryBidRepository from '@/api/RegistryBidRepository'
import responseRequestRepository from './responseRequestRepository'
import responsesRepository from './responsesRepository'
import smsRepository from '@/api/smsRepository'
import stevedoresRepository from './stevedoresRepository'
import tableOfPayments from '@/api/tableOfPayments'
import totalReport from './totalReport'
import userOrganizationsRepository from './userOrganizationsRepository'
import welcomePageRepository from '@/api/welcomePageRepository'

const repositories = {
  registryBidRepository,
  smsRepository,
  tableOfPayments,
  auth: AuthRepository,
  libs: libsRepository,
  auto: autoRepository,
  contragents: contragentsRepository,
  contragentsGroup: contragentsGroupRepository,
  addContragents: addContragentsGroupRepository,
  group: groupRepository,
  kladr: kladrRepository,
  messages: messagesRepository,
  file: FileRepository,
  check: CheckRepository,
  profile: profileRepository,
  bids: bidsRepository,
  approvements: approvementsRepository,
  doc: documentRepository,
  driver: driverRepository,
  loadDay: loadDayReposytory,
  document: documentRepository,
  totalSearch: totalSearchRepository,
  users: usersRepository,
  edmUsers: edmUsersRepository,
  callCenter: callCenterRepository,
  clients: clientsRepository,
  managers: managersRepository,
  ttn: ttnRepository,
  hardware: hardwareRepository,
  statistic: statisticRepository,
  contractsRepository,
  responses: responsesRepository,
  stevedores: stevedoresRepository,
  userOrganizations: userOrganizationsRepository,
  payments: paymentsRepository,
  acts: actsRepository,
  organizations: organizationsRepository,
  totalReport,
  comments: commentsRepository,
  welcomePage: welcomePageRepository,
  registerOfPayments,
  noPaper: noPaperRepository,
  responseRequest: responseRequestRepository,
  pole: poleRepository,
}

export const RepositoryFactory = {
  get: name => repositories[name],
}
